// Import the functions you need from the SDKs you need
import { initializeApp } from "@firebase/app";
import { getAuth, signInWithPopup, TwitterAuthProvider, signOut } from "@firebase/auth";
import axios from 'axios';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAdze0YlVsz45JTz7fvosCaJcT5J4mhcUY",
    authDomain: "dev-eternaldragons.firebaseapp.com",
    projectId: "dev-eternaldragons",
    storageBucket: "dev-eternaldragons.appspot.com",
    messagingSenderId: "76566469704",
    appId: "1:76566469704:web:0cb4687dedcc056553cc7d",
    measurementId: "G-1QV0562EPP"
};

//
export async function signInWithTwitter(userAccessToken: string) {
    // Initialize Firebase
    const app = initializeApp(firebaseConfig);
    const auth = getAuth(app);
    const provider = new TwitterAuthProvider();

    //
    await signInWithPopup(auth, provider)
        .then(async (result) => {
            console.log("_IN 1_")
            console.log(result);
            const credential = TwitterAuthProvider.credentialFromResult(result);
            console.log(credential);

            if (credential) {
                const token = credential.accessToken;
                const secret = credential.secret;
                console.log("_IN 2_")
                console.log(`${token} - ${secret}`)

                let reqOptions = {
                    headers: {
                        'Content-type': 'application/json',
                        'Authorization': userAccessToken
                    }
                }

                let reqData = { twitterAccessToken: token, twitterTokenSecret: secret };

                try {
                    let res = await axios.post(`${process.env.NEXT_PUBLIC_GATE}/link/twitter`, reqData, reqOptions);
                    console.log("_RES_")
                    console.log(res);


                    console.log(auth.currentUser?.displayName);
                }
                catch (e) {
                    console.log("_ERROR2");
                    console.error(e);
                }
            }
        }).catch((error) => {
            console.log("_ERROR")
            console.log(error)
            // Handle Errors here.
            const errorCode = error.code;
            const errorMessage = error.message;
            // The email of the user's account used.
            const email = error.customData.email;
            // The AuthCredential type that was used.
            const credential = TwitterAuthProvider.credentialFromError(error);
            // ...
        });
}


export async function signOutFromTwitter() {
    const app = initializeApp(firebaseConfig);
    const auth = getAuth(app);

    if (auth.currentUser) {
        await signOut(auth);
        console.log("_User singout from firebase");
    }
}
